module.exports = {"closeButtonText":"Fermer","thumbNailAlt":"Aperçu","next":"Page suivante","previous":"Page précédente","addNote":"Ajouter une note..."}


//////////////////
// WEBPACK FOOTER
// ./translations/fr.json
// module id = 21
// module chunks = 0